'use client'

import { FC, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import styles from './styles.module.scss'
import SVG from 'react-inlinesvg'
import upArrowDark from '@/assets/icons/up-arrow-dark.svg'

export const ScrollButton: FC = () => {
  const THRESHOLD_SCROLL = 400
  const [scrolledPastThreshold, setScrolledPastThreshold] = useState(false)
  const [mounted, setMounted] = useState(false)

  const handleScroll = () => {
    setScrolledPastThreshold(window.scrollY > THRESHOLD_SCROLL)
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0 })
  }

  useEffect(() => {
    setMounted(true)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const iconSrc =
    typeof upArrowDark === 'string' ? upArrowDark : upArrowDark.src

  const button = scrolledPastThreshold ? (
    <button
      onClick={scrollToTop}
      className={styles.scrollButton}
      aria-label="Scroll to top"
      type="button"
    >
      <SVG src={iconSrc} />
    </button>
  ) : null

  return mounted ? createPortal(button, document.body) : null
}
